import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import CtaLink from "~/components/atoms/CtaLink"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import TextCut from "~/components/molecules/TextCut"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import SeminarHead from "~/components/organisms/SeminarHead"
import Table from "~/components/organisms/Table"
import { SpacingSize, Color, TextSize, LineHeight, IsPC, IsMobile, Z } from "~/consts/style-mixins"
import { staticPath, internalLink } from "~/services/helper"

export default class SeminarDetail extends React.Component {
  render() {
    const crumbs = [
      {
        name: "就活セミナー・就活対策講座一覧",
        link: internalLink(`/seminars`),
      },
      {
        name: `個別の就活相談会`,
        link: internalLink(`/seminars/3`),
      },
    ]

    return (
      <>
        <Head>
          <title>個別の就活相談会</title>
          <meta
            name="description"
            content={`就職活動をしていく中で自分のやりたいことが見つからない、企業を絞れないなど悩んでいる方も多いのではないでしょうか？就活相談会ではキャリアアドバイザーに就活の相談を無料でいただけます。`}
          />
          <meta property="og:title" content="個別の就活相談会" />
          <meta
            property="og:description"
            content="就職活動をしていく中で自分のやりたいことが見つからない、企業を絞れないなど悩んでいる方も多いのではないでしょうか？就活相談会ではキャリアアドバイザーに就活の相談を無料でいただけます。"
          />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header logoType="Plain" />
        <StyledContainerWrapper>
          <Container size="Medium">
            <SeminarHead title="個別の就活相談会" bgSrc={staticPath("/static/images/seminar/seminars-3.png")} />
            <div>
              <StyledSchduleCardWrapper></StyledSchduleCardWrapper>
              <StyledEachItemWrapper>
                <TextCut cutPoint={240} size="Medium">
                  {`就職活動をしていく中で自分のやりたいことが見つからない、企業を絞れないなど悩んでいる方も多いのではないでしょうか？就活相談会ではキャリアアドバイザーに就活の相談を無料でいただけます。\nポイント１：専属のキャリアアドバイザーと1対1で就活相談できる\nポイント２：ヒアリングを通して強みや指向性などを一緒に分析\nポイント３：就活だけでなく、より先の将来を見据えた戦略的なキャリアの築き方が知れる`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">こんな方におすすめ</StyledHeading>
                <TextCut cutPoint={240} size="Medium">
                  {`・いろんな企業をみたけど、どれも魅力的で自分の軸がわからなくなった\n・業界絞って考えているけど本当にこれでいいのか不安\n・自己分析や軸に対してフィードバックが欲しい`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledTableWrapper>
                <StyledHeading type="SubHero">開催概要</StyledHeading>
                <Table
                  items={[
                    {
                      name: "対象",
                      content: "2021年3月までに大学院・大学を卒業または卒業見込みの方",
                    },
                    {
                      name: "参加費",
                      content: "無料",
                    },
                    {
                      name: "参加特典",
                      content: "Infraのキャリアアドバイザーが本選考内定までサポート",
                    },
                    {
                      name: "持ち物",
                      content: "筆記用具・ノート",
                    },
                    {
                      name: "服装",
                      content: "自由。ラフな格好で構いません。",
                    },
                  ]}
                />
              </StyledTableWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">開催場所</StyledHeading>
                <StyledPlace> 弊社代官山オフィス</StyledPlace>
                <StyledAddress>東京都渋谷区猿楽町30-8ツインビル代官山B棟303</StyledAddress>
              </StyledEachItemWrapper>
            </div>
          </Container>
        </StyledContainerWrapper>
        <Breadcrumb crumbs={crumbs} />
        <ActionWrapper className="gtm_seminar-apply">
          <CtaLink
            size="Medium"
            href={`https://docs.google.com/forms/d/1l1xPwenQCJIr2bHWQO9d-_YDqF1EaohiJy1m1tFyN0w/edit`}
            target="_blank"
          >
            申し込みページへ (日程を選択できます)
          </CtaLink>
        </ActionWrapper>
        <Footer />
      </>
    )
  }
}

const StyledContainerWrapper = styled.div`
  ${IsPC(css`
    padding: 48px 0;
  `)}
  ${IsMobile(css`
    padding: 24px 0 32px;
  `)}
`
const StyledEachItemWrapper = styled.div`
  margin-bottom: ${SpacingSize["2XL"]}px;
  &:last-child {
    margin-bottom: 0;
  }
`
const StyledHeading = styled(Typography)`
  margin-bottom: ${SpacingSize.XS}px;
  color: ${Color.Primary};
`
const StyledTableWrapper = styled.div`
  margin: 16px 0 32px;
`
const StyledPlace = styled.div`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.M}px;
  font-weight: bold;
  line-height: ${LineHeight.M}%;
`
const StyledAddress = styled.div`
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
  font-size: ${TextSize.S}px;
`
const StyledSchduleCardWrapper = styled.div`
  margin-top: ${SpacingSize.XL}px;
`
const ActionWrapper = styled.div`
  text-align: center;
  width: 100%;
  max-width: 480px;
  position: fixed;
  bottom: 16px;
  z-index: ${Z.Child};
  ${IsPC(css`
    left: 50%;
    margin-left: -240px;
  `)}
  ${IsMobile(css`
    padding: 0 16px;
    max-width: none;
    left: 0;
    margin-left: 0;
  `)}
`
